var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultipleChoices({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.27091 1.66675C2.83267 1.66675 1.66675 2.83267 1.66675 4.27092V15.7292C1.66675 17.1675 2.83267 18.3334 4.27092 18.3334H15.7292C17.1675 18.3334 18.3334 17.1675 18.3334 15.7292V4.27091C18.3334 2.83267 17.1675 1.66675 15.7292 1.66675H4.27091ZM14.3568 7.7423C14.8357 7.20588 14.7891 6.38277 14.2527 5.90382C13.7163 5.42488 12.8932 5.47147 12.4142 6.00789L8.73521 10.1284L7.84637 9.13289C7.36742 8.59647 6.5443 8.54988 6.00789 9.02882C5.47147 9.50777 5.42488 10.3309 5.90382 10.8673L7.76394 12.9506C8.01098 13.2273 8.36429 13.3855 8.73521 13.3855C9.10613 13.3855 9.45945 13.2273 9.70649 12.9506L14.3568 7.7423Z",
    fill: "#23242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultipleChoices);
export default __webpack_public_path__ + "static/media/multiple-choices.15ba1363424a5c75050abafed13c127e.svg";
export { ForwardRef as ReactComponent };